import { useEffect } from 'react'
import { useCurrentUserQuery } from '@entities/user'
import { useSession } from '@shared/lib/auth/session-store'

export function SessionHydrator() {
  const token = useSession((state) => state.token)
  const setUser = useSession((state) => state.setUser)
  const { data } = useCurrentUserQuery(Boolean(token))

  useEffect(() => {
    if (data) {
      setUser(data)
    }
  }, [data, setUser])

  return null
}
